import React, { useEffect, useState } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import { LineChart, XAxis, CartesianGrid, ReferenceLine, ResponsiveContainer, YAxis, Line } from 'recharts'
import { connect, useSelector } from 'react-redux'
import { useTranslation, withTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import ActivityBoxInvitations from 'srcReact/Dashboard/components/common/ActivityBoxInvitations'

const InviteAcceptanceRateGraph = ({ acceptaceRate, acceptanceRateVariant, graphData }) => {
  const { t } = useTranslation()
  const [data, setData] = useState([])
  const {
    common: { isDesktop }
  } = useSelector((state) => state)

  useEffect(() => {
    if (graphData) {
      setData([
        {
          uv: parseInt(graphData[3]?.value) || 0,
          variant: graphData[3]?.value
        },
        {
          uv: parseInt(graphData[2]?.value) || 0,
          variant: graphData[2]?.value
        },
        {
          uv: parseInt(graphData[1]?.value) || 0,
          variant: graphData[1]?.value
        },
        {
          uv: parseInt(graphData[0]?.value) || 0,
          variant: graphData[0]?.value
        }
      ])
    }
  }, [graphData])

  return graphData?.length > 0 ? (
    <div className={styles.graphContainer}>
      <div className={styles.left}>
        <div className={styles.mainNumber}>{acceptaceRate}</div>
        <div className={styles.title}>{t('dashboard.invitations.empty.acceptanceRate')}</div>
        <p className={`${styles.boxNumberVariation}  ${parseInt(acceptanceRateVariant) < 0 && 'down'}`}>
          <Icon name='grow' size='small' /> {acceptanceRateVariant}
        </p>
      </div>
      <div className={styles.graph}>
        <ResponsiveContainer aspect={isDesktop ? 0 : 2}>
          <LineChart data={data} isAnimationActive={false}>
            <CartesianGrid strokeArray='5' strokeWidth={2} stroke='#d4d4e0' vertical={false} />
            <XAxis hide={false} strokeWidth={0} stroke={'#28363d'} interval={0} tick={false} dy={10} />
            <YAxis type='number' domain={['dataMin', 'dataMax']} hide={true} />
            <Line
              type='linear'
              dataKey='uv'
              stroke='#82ca9d'
              strokeWidth={3}
              dot={{ stroke: '#feb200', strokeWidth: 1 }}
            />
            <ReferenceLine y={0} stroke='black' />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  ) : (
    <ActivityBoxInvitations className={styles.emptyData} activityText={t('dashboard.invitations.empty.activityText')} />
  )
}

export default InviteAcceptanceRateGraph
